import { createFileRoute } from "@tanstack/react-router";
import { ResidentVisitsPage } from "@/components/app/portal/pages/resident-visits-page";

export const Route = createFileRoute("/family-portal/$residentId/visits")({
  head: () => ({ meta: [{ title: "Video visits | People AI" }] }),
  component: FamilyVisits,
});

function FamilyVisits() {
  const { residentId } = Route.useParams();
  return <ResidentVisitsPage kind="family" residentId={residentId} />;
}
